export default "__VITE_ASSET__wvSHj$c7__"